import React, { PureComponent } from 'react';
import {
  Card, CardBody, Col, Button, ButtonToolbar
} from 'reactstrap';  
import { reduxForm } from 'redux-form';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { hasAccess } from "../../Services/SecurityService";
import { addSubstanciaUso, updateSubstanciaUso } from "../../Services/SubstanciaUsoService";
import { FullWideNotification } from '../../../shared/components/Notification';
import NotificationSystem from 'rc-notification';

let notificationTC = null;

class CrudEdit extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      substancias: [],
      checkboxSubstancias: [],
      checkboxSubstanciasSelected: [],
      data: {
        id: '',
        code: '',
        name: '',
        status: '',
        deleted: '',
        createdAt: '',
        updatedAt: ''
      }
    };
  }

  handleSubmit(e){
    const data = { ...this.state.data }

    if(this.validateEntries()){

      if(data.status === undefined || data.status === null || data.status === ''){
        data['status'] = 'ATIVO';
      }
      data['nameCarga'] = data.name;

      let request = {
        substanciaUso: data,
        substanciaSubstanciaUsoList: this.getSubstanciaUsoSubstancia()
      };
  
      if(data.id === undefined || data.id === null || data.id === ''){
        addSubstanciaUso(request)
        .then(obj => {
          if(obj !== null && obj !== undefined && obj.error === undefined){
            if(obj.erros.length === 0){
              this.props.updateTable({}, this.props.t('forms.dataCreateSuccess'));
              this.clear();              
            }else{
              if(obj.erros !== undefined && obj.erros !== undefined && obj.erros.length > 0){
                for(let i = 0; i < obj.erros.length; i++){
                  this.show('danger', this.props.t('erros.'+obj.erros[i]));
                }
              }
            }
          } else {
            this.show('danger', this.props.t('forms.dataCreateError'));
          }
        });

      }else{
        updateSubstanciaUso(request)
        .then(obj => {
          if(obj !== null && obj !== undefined && obj.error === undefined){
            if(obj.erros.length === 0){
              this.props.updateTable(obj, this.props.t('forms.dataUpdateSuccess'));
            }else{
              if(obj.erros !== undefined && obj.erros !== undefined && obj.erros.length > 0){
                for(let i = 0; i < obj.erros.length; i++){
                  this.show('danger', this.props.t('erros.'+obj.erros[i]));
                }
              }  
            }
          } else {
            this.show('danger', this.props.t('forms.dataUpdateError'));
          }
        });
      }
    }
  }

  validateEntries(){
    const data = { ...this.state.data }
    let validated = true;

    if(data.code === undefined || data.code === null || data.code === ''){
      this.show('danger', this.props.t('forms.requiredFieldCode'));
      validated = false;
    }

    if(data.name === undefined || data.name === null || data.name === ''){
      this.show('danger', this.props.t('forms.requiredFieldName'));
      validated = false;
    }

    return validated;  
  }

  getSubstanciaUsoSubstancia() {
    let substanciaSubstanciaUso = [];
    if(this.state.checkboxSubstanciasSelected.length > 0){
      for(let j = 0; j < this.state.checkboxSubstanciasSelected.length; j++){
        for(let i = 0; i < this.state.substancias.length; i++){
          if(this.state.checkboxSubstanciasSelected[j].value === this.state.substancias[i].id){
            substanciaSubstanciaUso.push( {substancia: this.state.substancias[i]} );
            break;
          }
        }
      }
    }
    return substanciaSubstanciaUso;
  }

  loadData(selected, substancias, substanciaSubstanciaUso) {
    let options = [];
    let optionsSelected = [];
    let obj = {};

    if(substancias !== undefined && substancias !== null && substancias.length > 0 && this.state.substancias.length === 0){
      if(substanciaSubstanciaUso !== undefined && substanciaSubstanciaUso !== null && 
        substanciaSubstanciaUso.substanciaSubstanciaUsoList !== null && substanciaSubstanciaUso.substanciaSubstanciaUsoList !== undefined &&
        substanciaSubstanciaUso.substanciaSubstanciaUsoList.length > 0){
        for(let i = 0; i < substancias.length; i++){
          obj = {value:substancias[i].id, label: substancias[i].name, checked: false, checkedAll: false};
          for(let j = 0; j < substanciaSubstanciaUso.substanciaSubstanciaUsoList.length; j++){
            if(substancias[i].id === substanciaSubstanciaUso.substanciaSubstanciaUsoList[j].substancia.id){
              obj.checked = true;
              optionsSelected.push(obj);
              break;
            }
          }
          options.push(obj);
        }
      }else{
        for(let i = 0; i < substancias.length; i++){
          options.push({value:substancias[i].id, label: substancias[i].name, checked: false, checkedAll: false});
        }
      }
      
      this.setState({ 
        checkboxSubstancias: options,
        checkboxSubstanciasSelected: optionsSelected,
        substancias: substancias
      });
    }

    if(selected !== undefined && selected !== null){
      if(selected.id === 0){
        this.clear();
      }else {
        this.setState({ 
          data: selected
        }, () => {});
      }
    }
  }

  componentDidMount() {
    const { selected, substancias, substanciaSubstanciaUso } = this.props;
    this.loadData(selected, substancias, substanciaSubstanciaUso);
    NotificationSystem.newInstance({ style: { top: 65 } }, n => notificationTC = n);
  }

  componentDidUpdate(props, state) {
    if(props.selected !== this.props.selected || props.substancias !== this.props.substancias || props.substanciaSubstanciaUso !== this.props.substanciaSubstanciaUso){
      this.loadData(this.props.selected, this.props.substancias, this.props.substanciaSubstanciaUso);
    }
  }

  componentWillUnmount() {
    notificationTC.destroy();
  }
  
  updateField(event) {
    const data = { ...this.state.data }
    data[event.target.name] = event.target.value
    this.setState({ data })
  }

  updateCheckboxSubstancia(event) {
    let selecteds = [];

    event.checked = !event.checked;
    if(this.state.checkboxSubstanciasSelected.length > 0){
      for(let i = 0; i < this.state.checkboxSubstanciasSelected.length; i++){
        if(this.state.checkboxSubstanciasSelected[i].value !== event.value){
          selecteds.push(this.state.checkboxSubstanciasSelected[i]);
        }
      }
    }
    if(event.checked){
      selecteds.push(event);
    }

    this.setState({ 
      checkboxSubstanciasSelected: selecteds.sort((a, b) => (a.label > b.label) ? 1 : -1)
    });
  }

  clear(){
    console.log("clear edit");
    const data = { ...this.state.data }
    data['id'] = '';
    data['code'] = '';
    data['name'] = '';
    data['status'] = '';
    data['deleted'] = '';
    data['createdAt'] = '';
    data['updatedAt'] = '';
    this.setState({ 
      data,
      checkboxSubstanciasSelected: []
    }, () => {});
  }

  cancel(event) {
    this.clear();
    this.props.updateTable({});
  }

  show = (color, message) => {
    return notificationTC.notice({
      content: <FullWideNotification
        color={color}
        message={message}
        />,
      duration: 3,
      closable: true,
      style: { top: 0, left: 0 },
      className: `full ltr-support`,
    });
  };

  render() {
    const { t } = this.props;
    const { data } = this.state;
    
    let notOK = !hasAccess("MENU_SUBSTANCE_USE_SAVE");

    let isEdit = false;
    if(this.state.data.id !== '' && this.state.data.id > 0){
      isEdit = true;
    }

    let checkboxesSubstancias = [];
    let checked = false;

    let total = this.state.checkboxSubstancias.length;
    if(total > 0){
      for(let i = 0; i < total; i++){
        checked = false;
        if(this.state.checkboxSubstanciasSelected.includes(this.state.checkboxSubstancias[i])){
          checked = true;
        }
        checkboxesSubstancias.push(
          <div key={"divsubstancias_"+this.state.checkboxSubstancias[i].value} className='form__form-inline' style={{width: '210px'}}>
            <input type="checkbox" 
              id={"checkboxsubstancias_"+this.state.checkboxSubstancias[i].value} 
              name={"checkboxsubstancias_"+this.state.checkboxSubstancias[i].value} 
              style={{float: 'left', width: '30px', height: '18px'}}
              onChange={e => this.updateCheckboxSubstancia(this.state.checkboxSubstancias[i])}
              checked={checked} 
            />
              <label 
                key={"labelsubstancias_"+this.state.checkboxSubstancias[i].value}
                htmlFor={"checkboxsubstancias_"+this.state.checkboxSubstancias[i].value} 
                style={{margin: 0, height: '25px'}}>
                {this.state.checkboxSubstancias[i].label}
              </label>
          </div>
        );
      }
    }

    return (
      <Col md={12} lg={12}>
        <Card>
          <CardBody>
            <div className="form__form-group">
              <h3 className="page-subhead subhead">{t('forms.createUpdate')}</h3>
            </div>
            <div className="form">

              <div className="form__form-group">
                <span title={t('forms.requiredField')} className="form__form-group-label">
                  {t('forms.code')} <span style={{color: "#ff0000"}}>*</span>
                </span>
                <div className="form__form-group-field">
                  <input type="hidden" 
                    name="id"
                    value={this.state.data.id} />
                  <input type="text" 
                    name="code"
                    value={this.state.data.code}
                    onChange={e => this.updateField(e)}
                    required
                  />
                </div>
              </div>

              <div className="form__form-group">
                <span title={t('forms.requiredField')} className="form__form-group-label">
                  {t('forms.name')} <span style={{color: "#ff0000"}}>*</span>
                </span>
                <div className="form__form-group-field">
                  <input type="text" 
                    name="name"
                    value={this.state.data.name}
                    onChange={e => this.updateField(e)}
                    required
                  />
                </div>
              </div>

              <div className="form__form-group">
                <span title={t('forms.requiredField')} className="form__form-group-label">
                  {t('forms.substancia_form.title')} 
                </span>
                <div className="form__form-group-field" 
                  style={{border: '1px solid #CCCCCC', height: '160px', overflowY: 'auto', 
                          display: 'flow-root', flexWrap: 'wrap', paddingTop: '5px'}}>
                  
                  {checkboxesSubstancias}

                </div>
              </div>
              
              <div className="form__form-group">
                <span className="form__form-group-label">
                  {t('forms.status')}
                </span>
                <div className="form__form-group-field">
                  <label className="radio-btn">
                    <input className="radio-btn__radio"
                      name="status"
                      type="radio"
                      value={t('forms.ativo')}
                      onChange={e => this.updateField(e)}
                      checked={this.state.data.status === 'ATIVO' ? true : false}
                    />
                    <span className="radio-btn__radio-custom"></span>
                    <span className="radio-btn__label">{t('forms.ativo')}</span>
                  </label>
                  <label className="radio-btn">
                    <input className="radio-btn__radio"
                      name="status"
                      type="radio"
                      value={t('forms.inativo')}
                      onChange={e => this.updateField(e)}
                      checked={this.state.data.status === 'INATIVO' ? true : false}
                    />
                    <span className="radio-btn__radio-custom"></span>
                    <span className="radio-btn__label">{t('forms.inativo')}</span>
                  </label>
                </div>
              </div>
              <ButtonToolbar className="form__button-toolbar">
                <Button color="primary" type="submit" disabled={notOK}
                  onClick={e => this.handleSubmit(e)}>
                  {t('forms.save')}
                </Button>
                <Button type="button" onClick={e => this.cancel(e)}>
                  {isEdit ? t('forms.voltar') : t('forms.cancel')}
                </Button>
              </ButtonToolbar>
            </div>
          </CardBody>
        </Card>
      </Col>
    );
  }
}

export default reduxForm({
  form: 'substanciaUsoEdit', 
})(withTranslation('common')(CrudEdit));
